import React from 'react';
import classNames from 'classnames';
const AdditionalServicesCard = props => {
  const { headerText, imageUrl, imgClass } = props;

  return (
    <div className="relative h-[107px] w-[196px] rounded-[5px] bg-[#EAE4EC] flex items-center">
      <div className="relative z-[2] px-[16px]">
        <h3 className="max-w-[100px] text-[14px] font-[700] leading-[17px]">{headerText}</h3>
      </div>
      <img src={imageUrl} className={classNames(`absolute z-[1] w-[100px] top-0 right-0 fade-in-from-bottom`, imgClass)} alt={headerText} />
    </div>
  );
};

export default AdditionalServicesCard;
